import { render, staticRenderFns } from "./normal-article.vue?vue&type=template&id=730aa1b0&scoped=true"
import script from "./normal-article.vue?vue&type=script&lang=js"
export * from "./normal-article.vue?vue&type=script&lang=js"
import style0 from "./normal-article.vue?vue&type=style&index=0&id=730aa1b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730aa1b0",
  null
  
)

export default component.exports